import actions from './constants';

export const updateDictionaryFields = (category, code, dictionaryUUID, properties, fieldUUID, template) => ({
  type: actions.UPDATE_DICTIONARY_FIELDS,
  category,
  code,
  dictionaryUUID,
  properties,
  fieldUUID,
  template,
});

export const updateDictionaryFieldType = (
  category,
  code,
  dictionaryUUID,
  fieldType,
  fieldConstraint,
  fieldUUID,
  pmnFunctions,
  template,
) => ({
  type: actions.UPDATE_DICTIONARY_FIELD_TYPE,
  category,
  code,
  dictionaryUUID,
  fieldType,
  fieldConstraint,
  fieldUUID,
  pmnFunctions,
  template,
});

export const insertActiveDictionary = (category, code, properties, template) => ({
  type: actions.INSERT_ACTIVE_DICTIONARY,
  category,
  code,
  properties,
  template,
});

export const updateActiveDictionary = (category, code, dictionaryUUID) => ({
  type: actions.UPDATE_ACTIVE_DICTIONARY,
  category,
  code,
  dictionaryUUID,
});

export const deleteActiveDictionary = (category, code, dictionaryUUID, template) => ({
  type: actions.DELETE_ACTIVE_DICTIONARY,
  category,
  code,
  dictionaryUUID,
  template,
});

export const updateDictionaryProperties = (category, code, dictionaryUUID, properties, template) => ({
  type: actions.UPDATE_DICTIONARY_PROPERTIES,
  category,
  code,
  dictionaryUUID,
  properties,
  template,
});

export const showDictionaryField = (category, code, activeFieldUUID, activeLookupName, withValidation) => ({
  type: actions.SHOW_DICTIONARY_FIELD,
  category,
  code,
  activeFieldUUID,
  activeLookupName,
  withValidation,
});

export const hideDictionaryField = () => ({
  type: actions.HIDE_DICTIONARY_FIELD,
});

export const updateActiveLookup = (name) => ({
  type: actions.UPDATE_ACTIVE_LOOKUP,
  name,
});

export const updateActiveLookupType = (dataType, pmnFunctions) => ({
  type: actions.UPDATE_ACTIVE_LOOKUP_TYPE,
  dataType,
  pmnFunctions,
});

export const updateActiveField = (fieldUUID) => ({
  type: actions.UPDATE_ACTIVE_FIELD,
  fieldUUID,
});

export const showDictionaryLookups = (category, code, activeLookup, withValidation) => ({
  type: actions.SHOW_DICTIONARY_LOOKUPS,
  category,
  code,
  activeLookup,
  withValidation,
});

export const hideDictionaryLookups = () => ({
  type: actions.HIDE_DICTIONARY_LOOKUPS,
});

export const showEditDictionary = (category, code, dictionaryUUID, isNew) => ({
  type: actions.SHOW_EDIT_DICTIONARY,
  category,
  code,
  dictionaryUUID,
  isNew,
});

export const hideEditDictionary = () => ({
  type: actions.HIDE_EDIT_DICTIONARY,
});

export const updateActiveDictionaryEdit = (properties) => ({
  type: actions.UPDATE_ACTIVE_DICTIONARY_EDIT,
  properties,
});

export const addDictionaryField = (category, code, template) => ({
  type: actions.ADD_DICTIONARY_FIELD,
  category,
  code,
  template,
});

export const deleteDictionaryField = (category, code, dictionaryUUID, fieldUUID, template) => ({
  type: actions.DELETE_DICTIONARY_FIELD,
  category,
  code,
  dictionaryUUID,
  fieldUUID,
  template,
});

export const copyDictionaryField = (category, code, dictionaryUUID, fieldUUID, template) => ({
  type: actions.COPY_DICTIONARY_FIELD,
  category,
  code,
  dictionaryUUID,
  fieldUUID,
  template,
});

export const addLookupItem = () => ({
  type: actions.ADD_LOOKUP_ITEM,
});

export const deleteLookupItem = (lookupItemUUID) => ({
  type: actions.DELETE_LOOKUP_ITEM,
  lookupItemUUID,
});

export const updateLookupItemProperties = (lookupItemUUID, properties) => ({
  type: actions.UPDATE_LOOKUP_ITEM_PROPERTIES,
  lookupItemUUID,
  properties,
});

export const showEditActiveLookup = (isNew) => ({
  type: actions.SHOW_EDIT_ACTIVE_LOOKUP,
  isNew,
});

export const hideEditActiveLookup = (cancel) => ({
  type: actions.HIDE_EDIT_ACTIVE_LOOKUP,
  cancel,
});

export const updateLookupProperties = (properties) => ({
  type: actions.UPDATE_LOOKUP_PROPERTIES,
  properties,
});

export const updateActiveLookupProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_LOOKUP_PROPERTIES,
  properties,
});

export const deleteActiveLookup = () => ({
  type: actions.DELETE_ACTIVE_LOOKUP,
});

export const applyDictionaries = (template) => ({
  type: actions.APPLY_DICTIONARIES,
  template,
});

export const datasetDictionaryUpload = (category, code) => ({
  type: actions.DATASET_DICTIONARY_UPLOAD,
  category,
  code,
});

export const datasetDictionaryUploadSuccess = (category, code) => ({
  type: actions.DATASET_DICTIONARY_UPLOAD_SUCCESS,
  category,
  code,
});

export const datasetDictionaryUploadFail = (category, code) => ({
  type: actions.DATASET_DICTIONARY_UPLOAD_FAIL,
  category,
  code,
});

export const datasetDictionaryMessages = (category, code, msg, error) => ({
  type: actions.ADD_DATASET_DICTIONARY_UPLOAD_MESSAGE,
  category,
  code,
  msg,
  error,
});

export const datasetDictionaryFileRemoved = (category, code) => ({
  type: actions.REMOVE_DATASET_DICTIONARY_FILE_UPLOAD,
  category,
  code,
});

export const toggleDictionaryFieldsProperty = (category, code, dictionaryUUID, name, selected, template) => ({
  type: actions.TOGGLE_DICTIONARY_FIELDS_PROPERTY,
  category,
  code,
  dictionaryUUID,
  name,
  selected,
  template,
});

export const downloadDatasetDictionaries = (code) => ({
  type: actions.DOWNLOAD_DICTIONARIES,
  code,
});

export const downloadDatasetDictionariesError = (code, error) => ({
  type: actions.DOWNLOAD_DICTIONARIES_ERROR,
  code,
  error,
});
